import { Donut } from "@/pages/catalogs/models/Donut";
import { RollStatusTag } from "@/pages/catalogs/shared/components/RollStatusTag";
import { donutStatusCodes } from "@/shared/selectors/DonutStatusSelector";
import { ErrorModal } from "@dexteel/mesf-core";
import { Grid2, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Part } from "../../models/Part";
import { getDonuts } from "../../repositories/parts/DonutRepository";

type useDonutsProps = {
	partId: number;
	onError: (error: Error) => void;
	onSuccess?: (data: Donut[]) => void;
};

export const useDonuts = ({ partId, onError, onSuccess }: useDonutsProps) => {
	return useQuery<Donut[], Error>({
		queryKey: ["donuts", partId],
		queryFn: ({ signal }) => getDonuts({ partId }, signal),
		onError: onError,
		onSuccess: onSuccess,
	});
};

type Props = {
	part: Part | null;
};

export const SpecificDonutData = ({ part }: Props) => {
	const [error, setError] = useState("");
	const [donut, setDonut] = useState<Donut>();

	const { data: donuts } = useDonuts({
		partId: part?.PartId!,
		onError: (error) => setError(error.message),
		onSuccess: (data: Donut[]) => {
			setDonut(data[0]);
		},
	});

	return (
		<>
			<Grid2 container spacing={1}>
				<Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
					<TextField
						value={donut?.SectionFamilyName || ""}
						label="Section Family"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
					<TextField
						value={
							donutStatusCodes.find(
								(status) => status.Code === donut?.DonutStatusCode,
							)?.Name || ""
						}
						label="Status"
						variant="outlined"
						size="small"
						fullWidth
						disabled
						InputProps={{
							startAdornment: (
								<span
									style={{
										width: "25px",
										height: "25px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										marginRight: "8px",
										marginLeft: "8px",
									}}
								>
									<RollStatusTag
										status={{
											Code:
												donutStatusCodes.find(
													(status) => status.Code === donut?.DonutStatusCode,
												)?.Code ?? "",
											Name:
												donutStatusCodes.find(
													(status) => status.Code === donut?.DonutStatusCode,
												)?.Name ?? "",
										}}
									/>
								</span>
							),
						}}
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
					<TextField
						value={donut?.Width || ""}
						label="Width"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
					<TextField
						value={donut?.NewDiameter || ""}
						label="New Diameter"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
					<TextField
						value={donut?.Diameter || ""}
						label="Diameter"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
					<TextField
						value={donut?.ScrapDiameter || ""}
						label="Scrap Diameter"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
			</Grid2>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
